<template>
<div class="chapter">
<div class="inner_page">
<div id="toc">
<p class="toctitle">Contents</p>
<p class="toc"><a href="#/06_fm">Foreword</a></p>
<table class="table1" style="margin-bottom:0.5em;margin-top:0em;margin-left:-0.5em;width:60%;">
<tbody><tr>
<td style="width:15%"><a href="#/07_c1">Chapter One</a></td>
<td><a href="#/07_c1">The Lone Wolf Strikes</a></td>
</tr>
<tr>
<td><a href="#/08_c2">Chapter Two</a></td>
<td><a href="#/08_c2">Long Journey to the Front</a></td>
</tr>
<tr>
<td><span href="#/09_c3" title="Link target outside of Sample">Chapter Three</span></td>
<td><span href="#/09_c3" title="Link target outside of Sample">Bad Aircraft and Bad Luck</span></td>
</tr>
<tr>
<td><span href="#/10_c4" title="Link target outside of Sample">Chapter Four</span></td>
<td><span href="#/10_c4" title="Link target outside of Sample">From Albion to Zeppelins</span></td>
</tr>
<tr>
<td><span href="#/11_c5" title="Link target outside of Sample">Chapter Five</span></td>
<td><span href="#/11_c5" title="Link target outside of Sample">First Triumphs</span></td>
</tr>
<tr>
<td><span href="#/12_c6" title="Link target outside of Sample">Chapter Six</span></td>
<td><span href="#/12_c6" title="Link target outside of Sample">Bloody April</span></td>
</tr>
<tr>
<td><span href="#/13_c7" title="Link target outside of Sample">Chapter Seven</span></td>
<td><span href="#/13_c7" title="Link target outside of Sample">Transformations</span></td>
</tr>
<tr>
<td><span href="#/14_c8" title="Link target outside of Sample">Chapter Eight</span></td>
<td><span href="#/14_c8" title="Link target outside of Sample">Attack in the Darkness</span></td>
</tr>
<tr>
<td><span href="#/15_c9" title="Link target outside of Sample">Chapter Nine</span></td>
<td><span href="#/15_c9" title="Link target outside of Sample">Growing Success</span></td>
</tr>
<tr>
<td><span href="#/16_c10" title="Link target outside of Sample">Chapter Ten</span></td>
<td><span href="#/16_c10" title="Link target outside of Sample">A Hero at Last</span></td>
</tr>
<tr>
<td><span href="#/17_c11" title="Link target outside of Sample">Chapter Eleven</span></td>
<td><span href="#/17_c11" title="Link target outside of Sample">Winged Victory</span></td>
</tr>
<tr>
<td><span href="#/18_c12" title="Link target outside of Sample">Chapter Twelve</span></td>
<td><span href="#/18_c12" title="Link target outside of Sample">What Price Success?</span></td>
</tr>
<tr>
<td><span href="#/19_app" title="Link target outside of Sample">Appendix</span></td>
<td><span href="#/19_app" title="Link target outside of Sample">Aerial Victory List of William A. Bishop</span></td>
</tr>
</tbody></table>
<p class="toc"><span href="#/20_bib" title="Link target outside of Sample">Bibliography &amp; Sources</span></p>
<p class="toc"><span href="#/21_notes" title="Link target outside of Sample">Endnotes</span></p>
<p class="toc"><span href="#/22_maps" title="Link target outside of Sample">Maps</span></p>
<table class="table1" style="margin-bottom:0.5em;margin-top:0em;margin-left:-0.5em;width:60%;">
<tbody><tr>
<td style="width:15%">
</td><td><span href="#/22_maps#map1" title="Link target outside of Sample">60 Squadron Sector in 1917</span></td>
</tr>
<tr>
<td>
</td><td><span href="#/22_maps#map2" title="Link target outside of Sample">60 Squadron Sector in 1918</span></td>
</tr>
</tbody></table>
<p class="toc"><span href="#/23_ind" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_toc.vue?23bfa76c